import React, { useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { useDispatch, useSelector } from 'react-redux'
import { startCase } from 'lodash'
import { deletePaymentSource } from '../actions'

function PaymentSourceListing(props){
  const dispatch = useDispatch();
  const { kind, name, is_verified, id } = props
  const organization = useSelector(state=>state.organization)

  function handleClickVerify(){
    dispatch({type:'LOAD_VERIFY_PAYMENT_SOURCE_FORM', payload: { id, name } })
    dispatch({type:'SET_VERIFY_PAYMENT_SOURCE_CALLBACK_ACTION', payload: { callback_action: 'UPDATE_PAYMENT_SOURCES_UI' }})
    dispatch({type:'UPDATE_PAYMENT_SOURCES_UI', payload: {show: false}})
    dispatch({type:'UPDATE_VERIFY_PAYMENT_SOURCE_FORM_UI', payload: {show: true}})
  }
  
  return(
    <tr>
      <td className="text-capitalize">{(name)}</td>
      <td>{startCase(kind)}</td>
      {organization["pay_simple?"] ? null : (
        <td>
          {is_verified ? (
            <div className="badge badge-success">Verified</div>
          ) : (
            <div onClick={handleClickVerify} className="btn btn-sm btn-primary">
              Verify Now *
            </div>
          )}
        </td>
      )}
      <td className="text-center"><DeleteButton {...props}/></td>
    </tr>
  )
}

function DeleteButton(props){
  const dispatch = useDispatch()
  const [ confirm, setConfirm ] = useState(false)
  const [ isSubmitting, setIsSubmitting ] = useState(false)

  function handleClick(){
    if (!confirm){
      setConfirm(true)
      setTimeout(()=>{setConfirm(false)},3000)
    } else {
      dispatch(deletePaymentSource(props))
      setConfirm(false)
    }
  }


  return(
    <button onClick={handleClick} className={`btn btn-sm ${ confirm ? 'btn-danger' : 'btn-warning'}`}>
    {
      isSubmitting ? 
      <ClipLoader color="#ffffff" size={14}/> :
      confirm ? 'CONFIRM' : 'DELETE'
    }
    </button>
  )
}

export default PaymentSourceListing
